import axios, {AxiosRequestConfig} from "axios";
import {handleFileDownload} from "../Modules/Reports/ManagementReport/utils/postAndDownloadFile";
import {GATEWAY_URL_REPORT, GATEWAY_URL} from "../Config/Constants";


export const downloadFilePostMapping = (url: string, data: any, filename: string, successCallBack?: () => void, errorCallback?: (error: any) => void) => {
    const config: AxiosRequestConfig = {
        url: url,
        data,
        method: 'POST',
        responseType: 'blob'
    };

    axios({
        ...config,
        timeout: 40000
    })
        .then((response) => {
            handleFileDownload(response, filename, successCallBack, errorCallback);
        }).catch(error => {
        if (errorCallback) {
            errorCallback(error);
        }
    });
}


export const downloadFilePostMappingTeleObjectReportPage = (url: string, data: any, filename: string, successCallBack?: () => void, errorCallback?: (error: any) => void) => {
    const config: AxiosRequestConfig = {
        baseURL: GATEWAY_URL_REPORT,
        url: url,
        data,
        method: 'POST',
        responseType: 'blob'
    };


    axios({
        ...config,
        timeout: 40000
    })
        .then((response) => {
            handleFileDownload(response, filename, successCallBack, errorCallback);
        }).catch(error => {
        if (errorCallback) {
            errorCallback(error);
        }
    });
}